// @ts-ignore
var $d5909c9e2a02acdc$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(u) {
                    return n(r, t, u);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(u) {
                    return function(e) {
                        return n(r, t, u, e);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(u) {
                    return function(e) {
                        return function(i) {
                            return n(r, t, u, e, i);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(u) {
                    return function(e) {
                        return function(i) {
                            return function(o) {
                                return n(r, t, u, e, i, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, u) {
        return 3 === n.a ? n.f(r, t, u) : n(r)(t)(u);
    }
    function A4(n, r, t, u, e) {
        return 4 === n.a ? n.f(r, t, u, e) : n(r)(t)(u)(e);
    }
    function A5(n, r, t, u, e, i) {
        return 5 === n.a ? n.f(r, t, u, e, i) : n(r)(t)(u)(e)(i);
    }
    function A6(n, r, t, u, e, i, o) {
        return 6 === n.a ? n.f(r, t, u, e, i, o) : n(r)(t)(u)(e)(i)(o);
    }
    var t = {
        $: 0
    };
    function u(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var e = F2(u);
    function i(n) {
        for(var r = t, e = n.length; e--;)r = u(n[e], r);
        return r;
    }
    var o = F3(function(n, r, t) {
        for(var u = []; r.b && t.b; r = r.b, t = t.b)u.push(A2(n, r.a, t.a));
        return i(u);
    }), f = F3(function(n, r, t) {
        for(var u = Array(n), e = 0; n > e; e++)u[e] = t(r + e);
        return u;
    }), c = F2(function(n, r) {
        for(var t = Array(n), u = 0; n > u && r.b; u++)t[u] = r.a, r = r.b;
        return t.length = u, d(t, r);
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function s(n, r) {
        for(var t, u = [], e = b(n, r, 0, u); e && (t = u.pop()); e = b(t.a, t.b, 0, u));
        return e;
    }
    function b(n, r, t, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        if (t > 100) return u.push(d(n, r)), !0;
        for(var e in 0 > n.$ && (n = ln(n), r = ln(r)), n)if (!b(n[e], r[e], t + 1, u)) return !1;
        return !0;
    }
    function v(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = v(n.a, r.a)) || (t = v(n.b, r.b)) ? t : v(n.c, r.c);
        for(; n.b && r.b && !(t = v(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        var t = v(n, r);
        return 0 > t ? sn : t ? dn : an;
    });
    function d(n, r) {
        return {
            a: n,
            b: r
        };
    }
    var h = F2($);
    function $(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = u(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = u(n.a, r);
        return t;
    }
    var p = Math.ceil, g = Math.floor, m = Math.log, y = F2(function(n, r) {
        return r.split(n);
    }), w = F2(function(n, r) {
        return r.join(n);
    }), x = F2(function(n, r) {
        for(var t = r.length; t--;){
            var u = r[t], e = r.charCodeAt(t);
            if (56320 > e || e > 57343 || (u = r[--t] + u), !n(u)) return !1;
        }
        return !0;
    });
    function O(n) {
        return n + "";
    }
    function j(n) {
        return {
            $: 2,
            b: n
        };
    }
    var A = j(function(n) {
        return "number" != typeof n ? X("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? yn(n) : !isFinite(n) || n % 1 ? X("an INT", n) : yn(n);
    }), T = j(function(n) {
        return "boolean" == typeof n ? yn(n) : X("a BOOL", n);
    }), k = j(function(n) {
        return "number" == typeof n ? yn(n) : X("a FLOAT", n);
    }), N = j(function(n) {
        return yn(n);
    }), E = j(function(n) {
        return "string" == typeof n ? yn(n) : n instanceof String ? yn(n + "") : X("a STRING", n);
    }), J = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function q(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var R = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), S = F2(function(n, r) {
        return q(n, [
            r
        ]);
    }), C = F3(function(n, r, t) {
        return q(n, [
            r,
            t
        ]);
    }), L = F4(function(n, r, t, u) {
        return q(n, [
            r,
            t,
            u
        ]);
    }), _ = F5(function(n, r, t, u, e) {
        return q(n, [
            r,
            t,
            u,
            e
        ]);
    }), B = F6(function(n, r, t, u, e, i) {
        return q(n, [
            r,
            t,
            u,
            e,
            i
        ]);
    }), D = F2(function(n, r) {
        try {
            return I(n, JSON.parse(r));
        } catch (n) {
            return $n(A2(pn, "This is not valid JSON! " + n.message, r));
        }
    }), F = F2(function(n, r) {
        return I(n, r);
    });
    function I(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? yn(n.c) : X("null", r);
            case 3:
                return z(r) ? P(n.b, r, i) : X("a LIST", r);
            case 4:
                return z(r) ? P(n.b, r, M) : X("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return X("an OBJECT with a field named `" + e + "`", r);
                var o = I(n.b, r[e]);
                return cr(o) ? o : $n(A2(gn, e, o.a));
            case 7:
                var f = n.e;
                return z(r) ? r.length > f ? (o = I(n.b, r[f]), cr(o) ? o : $n(A2(mn, f, o.a))) : X("a LONGER array. Need index " + f + " but only see " + r.length + " entries", r) : X("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || z(r)) return X("an OBJECT", r);
                var c = t;
                for(var a in r)if (r.hasOwnProperty(a)) {
                    if (o = I(n.b, r[a]), !cr(o)) return $n(A2(gn, a, o.a));
                    c = u(d(a, o.a), c);
                }
                return yn(Pn(c));
            case 9:
                for(var s = n.f, b = n.g, v = 0; b.length > v; v++){
                    if (o = I(b[v], r), !cr(o)) return o;
                    s = s(o.a);
                }
                return yn(s);
            case 10:
                return o = I(n.b, r), cr(o) ? I(n.h(o.a), r) : o;
            case 11:
                for(var l = t, h = n.g; h.b; h = h.b){
                    if (o = I(h.a, r), cr(o)) return o;
                    l = u(o.a, l);
                }
                return $n(wn(Pn(l)));
            case 1:
                return $n(A2(pn, n.a, r));
            case 0:
                return yn(n.a);
        }
    }
    function P(n, r, t) {
        for(var u = r.length, e = Array(u), i = 0; u > i; i++){
            var o = I(n, r[i]);
            if (!cr(o)) return $n(A2(mn, i, o.a));
            e[i] = o.a;
        }
        return yn(t(e));
    }
    function z(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function M(n) {
        return A2(fr, n.length, function(r) {
            return n[r];
        });
    }
    function X(n, r) {
        return $n(A2(pn, "Expecting " + n, r));
    }
    var G = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function Y(n) {
        return n;
    }
    var W = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), H = 0;
    var K = !1, Q = [];
    function U(n) {
        if (Q.push(n), !K) {
            for(K = !0; n = Q.shift();)V(n);
            K = !1;
        }
    }
    function V(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, U(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var Z = F4(function(n, r, t, u) {
        return function(n, r, t, u, e) {
            var i = A2(F, n, r ? r.flags : void 0);
            cr(i) || a(2);
            var o = {}, f = t(i.a), c = f.a, s = function() {}, b = function(n, r) {
                var t;
                for(var u in nn){
                    var e = nn[u];
                    e.a && ((t = t || {})[u] = e.a(u, r)), n[u] = rn(e, r);
                }
                return t;
            }(o, v);
            function v(n, r) {
                var t = A2(u, n, c);
                s(c = t.a, r), en(o, t.b, e(c));
            }
            return en(o, f.b, e(c)), b ? {
                ports: b
            } : {};
        }(r, u, n.av, n.aD, n.aB);
    }), nn = {};
    function rn(n, r) {
        var t, u = {
            g: r,
            h: void 0
        }, e = n.c, i = n.d, o = n.e, f = n.f;
        function c(n) {
            return A2(W, c, {
                $: 5,
                b: function(r) {
                    var t = r.a;
                    return 0 === r.$ ? A3(i, u, t, n) : o && f ? A4(e, u, t.i, t.j, n) : A3(e, u, o ? t.i : t.j, n);
                }
            });
        }
        return u.h = (U(t = {
            $: 0,
            e: H++,
            f: A2(W, c, n.b),
            g: null,
            h: []
        }), t);
    }
    var tn = [], un = !1;
    function en(n, r, t) {
        if (tn.push({
            p: n,
            q: r,
            r: t
        }), !un) {
            un = !0;
            for(var u; u = tn.shift();)on(u.p, u.q, u.r);
            un = !1;
        }
    }
    function on(n, r, u) {
        var e, i = {};
        for(var o in fn(!0, r, i, null), fn(!1, u, i, null), n)(e = n[o]).h.push({
            $: "fx",
            a: i[o] || {
                i: t,
                j: t
            }
        }), U(e);
    }
    function fn(n, r, e, i) {
        switch(r.$){
            case 1:
                var o = r.k, f = function(n, r, t, u) {
                    function e(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? nn[r].e : nn[r].f, e, u);
                }(n, o, i, r.l);
                return void (e[o] = function(n, r, e) {
                    return e = e || {
                        i: t,
                        j: t
                    }, n ? e.i = u(r, e.i) : e.j = u(r, e.j), e;
                }(n, f, e[o]));
            case 2:
                for(var c = r.m; c.b; c = c.b)fn(n, c.a, e, i);
                return;
            case 3:
                return void fn(n, r.o, e, {
                    s: r.n,
                    t: i
                });
        }
    }
    var cn = F2(function(n, r) {
        return r;
    });
    var an = 1, sn = 0, bn = e, vn = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var u = t.d, e = n, i = A3(n, t.b, t.c, A3(vn, n, r, t.e));
            n = e, r = i, t = u;
        }
    }), ln = function(n) {
        return A3(vn, F3(function(n, r, t) {
            return A2(bn, d(n, r), t);
        }), t, n);
    }, dn = 2, hn = F3(function(n, r, t) {
        return r(n(t));
    }), $n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), gn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), yn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, On = {
        $: 1
    }, jn = x, An = h, Tn = G, kn = O, Nn = F2(function(n, r) {
        return A2(w, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), En = F2(function(n, r) {
        return i(A2(y, n, r));
    }), Jn = function(n) {
        return A2(Nn, "\n    ", A2(En, "\n", n));
    }, qn = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var u = t.b, e = n, i = A2(n, t.a, r);
            n = e, r = i, t = u;
        }
    }), Rn = function(n) {
        return A3(qn, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Sn = o, Cn = F3(function(n, r, t) {
        for(;;){
            if (v(n, r) >= 1) return t;
            var u = n, e = r - 1, i = A2(bn, r, t);
            n = u, r = e, t = i;
        }
    }), Ln = F2(function(n, r) {
        return A3(Cn, n, r, t);
    }), _n = F2(function(n, r) {
        return A3(Sn, n, A2(Ln, 0, Rn(r) - 1), r);
    }), Bn = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Dn = function(n) {
        var r = Bn(n);
        return r >= 97 && 122 >= r;
    }, Fn = function(n) {
        var r = Bn(n);
        return 90 >= r && r >= 65;
    }, In = function(n) {
        return Dn(n) || Fn(n) || function(n) {
            var r = Bn(n);
            return 57 >= r && r >= 48;
        }(n);
    }, Pn = function(n) {
        return A3(qn, bn, t, n);
    }, zn = F2(function(n, r) {
        return "\n\n(" + kn(n + 1) + ") " + Jn(Mn(r));
    }), Mn = function(n) {
        return A2(Xn, n, t);
    }, Xn = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, u = n.b, e = function() {
                    var n, r, u = (r = (n = t).charCodeAt(0), isNaN(r) ? On : xn(55296 > r || r > 56319 ? d(n[0], n.slice(1)) : d(n[0] + n[1], n.slice(2))));
                    if (1 === u.$) return !1;
                    var e, i = u.a, o = i.b;
                    return (Dn(e = i.a) || Fn(e)) && A2(jn, In, o);
                }();
                n = u, r = A2(bn, e ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                u = n.b;
                var i = "[" + kn(n.a) + "]";
                n = u, r = A2(bn, i, r);
                continue n;
            case 2:
                var o = n.a;
                if (o.b) {
                    if (o.b.b) {
                        var f = (r.b ? "The Json.Decode.oneOf at json" + A2(Nn, "", Pn(r)) : "Json.Decode.oneOf") + " failed in the following " + kn(Rn(o)) + " ways:";
                        return A2(Nn, "\n\n", A2(bn, f, A2(_n, zn, o)));
                    }
                    n = u = o.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(Nn, "", Pn(r)) : "!");
            default:
                var c = n.a, a = n.b;
                return (f = r.b ? "Problem with the value at json" + A2(Nn, "", Pn(r)) + ":\n\n    " : "Problem with the given value:\n\n") + Jn(A2(Tn, 4, a)) + "\n\n" + c;
        }
    }), Gn = 32, Yn = F4(function(n, r, t, u) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: u
        };
    }), Wn = [], Hn = p, Kn = F2(function(n, r) {
        return m(r) / m(n);
    }), Qn = Hn(A2(Kn, 2, Gn)), Un = A4(Yn, 0, Qn, Wn, Wn), Vn = f, Zn = g, nr = function(n) {
        return n.length;
    }, rr = F2(function(n, r) {
        return v(n, r) > 0 ? n : r;
    }), tr = c, ur = F2(function(n, r) {
        for(;;){
            var t = A2(tr, Gn, n), u = t.b, e = A2(bn, {
                $: 0,
                a: t.a
            }, r);
            if (!u.b) return Pn(e);
            n = u, r = e;
        }
    }), er = F2(function(n, r) {
        for(;;){
            var u = Hn(r / Gn);
            if (1 === u) return A2(tr, Gn, n).a;
            n = A2(ur, n, t), r = u;
        }
    }), ir = F2(function(n, r) {
        if (r.a) {
            var t = r.a * Gn, u = Zn(A2(Kn, Gn, t - 1)), e = n ? Pn(r.d) : r.d, i = A2(er, e, r.a);
            return A4(Yn, nr(r.c) + t, A2(rr, 5, u * Qn), i, r.c);
        }
        return A4(Yn, nr(r.c), Qn, Wn, r.c);
    }), or = F5(function(n, r, t, u, e) {
        for(;;){
            if (0 > r) return A2(ir, !1, {
                d: u,
                a: t / Gn | 0,
                c: e
            });
            var i = {
                $: 1,
                a: A3(Vn, Gn, r, n)
            };
            r -= Gn, u = A2(bn, i, u);
        }
    }), fr = F2(function(n, r) {
        if (n > 0) {
            var u = n % Gn;
            return A5(or, r, n - u - Gn, n, t, A3(Vn, u, n - u, r));
        }
        return Un;
    }), cr = function(n) {
        return !n.$;
    }, ar = D, sr = C, br = {
        $: -2
    }, vr = br, lr = F5(function(n, r, t, u, e) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: u,
            e: e
        };
    }), dr = F5(function(n, r, t, u, e) {
        if (-1 !== e.$ || e.a) {
            if (-1 !== u.$ || u.a || -1 !== u.d.$ || u.d.a) return A5(lr, n, r, t, u, e);
            var i = u.d;
            return o = u.e, A5(lr, 0, u.b, u.c, A5(lr, 1, i.b, i.c, i.d, i.e), A5(lr, 1, r, t, o, e));
        }
        var o, f = e.b, c = e.c, a = e.d, s = e.e;
        return -1 !== u.$ || u.a ? A5(lr, n, f, c, A5(lr, 0, r, t, u, a), s) : A5(lr, 0, r, t, A5(lr, 1, u.b, u.c, u.d, o = u.e), A5(lr, 1, f, c, a, s));
    }), hr = l, $r = F3(function(n, r, t) {
        if (-2 === t.$) return A5(lr, 0, n, r, br, br);
        var u = t.a, e = t.b, i = t.c, o = t.d, f = t.e;
        switch(A2(hr, n, e)){
            case 0:
                return A5(dr, u, e, i, A3($r, n, r, o), f);
            case 1:
                return A5(lr, u, e, r, o, f);
            default:
                return A5(dr, u, e, i, o, A3($r, n, r, f));
        }
    }), pr = F3(function(n, r, t) {
        var u = A3($r, n, r, t);
        return -1 !== u.$ || u.a ? u : A5(lr, 1, u.b, u.c, u.d, u.e);
    }), gr = function(n) {
        return A3(qn, F2(function(n, r) {
            return A3(pr, n.a, n.b, r);
        }), vr, n);
    }, mr = S, yr = function(n) {
        return A2(mr, gr, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, wr = J, xr = F4(function(n, r, t, u) {
        if (u.b) {
            var e = u.a, i = u.b;
            if (i.b) {
                var o = i.a, f = i.b;
                if (f.b) {
                    var c = f.a, a = f.b;
                    if (a.b) {
                        var s = a.b;
                        return A2(n, e, A2(n, o, A2(n, c, A2(n, a.a, t > 500 ? A3(qn, n, r, Pn(s)) : A4(xr, n, r, t + 1, s)))));
                    }
                    return A2(n, e, A2(n, o, A2(n, c, r)));
                }
                return A2(n, e, A2(n, o, r));
            }
            return A2(n, e, r);
        }
        return r;
    }), Or = F3(function(n, r, t) {
        return A4(xr, n, r, 0, t);
    }), jr = F2(function(n, r) {
        return A3(Or, F2(function(r, t) {
            return A2(bn, n(r), t);
        }), t, r);
    }), Ar = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Tr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kr = function(n) {
        return Ar(i([
            A2(mr, xn, n),
            Tr(On)
        ]));
    }, Nr = E, Er = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Jr = function(n) {
        return A2(mr, Er(""), kr(A2(wr, "meta", A2(mr, A2(hn, ln, A2(hn, jr(function(n) {
            return n.a + ": " + n.b;
        }), A2(hn, Nn("\n\n"), function(r) {
            return n ? "<!--\n\n" + r + "\n\n-->\n\n\n" : "\n<!--\n" + r + "\n-->";
        }))), yr(Nr)))));
    }, qr = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Rr = function(n) {
        return i(n.split(/\r\n|\r|\n/g));
    }, Sr = F2(function(n, r) {
        return A2(Nn, "\n", A2(jr, function(r) {
            return $(n, r);
        }, Rr(r)));
    }), Cr = R, Lr = Ar(i([
        Nr,
        A2(mr, Nn("\n"), qr(Nr))
    ])), _r = A2(mr, Er(""), kr(A2(mr, function(n) {
        return "\n" + n;
    }, A2(wr, "appendix", Lr)))), Br = T, Dr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fr = F2(function(n, r) {
        return Ar(A2(jr, function(n) {
            return A2(wr, n, r);
        }, n));
    }), Ir = k, Pr = O, zr = A, Mr = N, Xr = kr(A2(wr, "attributes", Ar(i([
        Nr,
        A2(mr, A2(hn, ln, A2(hn, jr(function(n) {
            return '"' + n.a + '"="' + n.b + '"';
        }), Nn(" "))), yr(Ar(i([
            Nr,
            A2(mr, kn, zr),
            A2(mr, Pr, Ir),
            A2(mr, function(n) {
                return n ? "true" : "false";
            }, Br),
            A2(mr, Tn(0), Mr)
        ]))))
    ])))), Gr = L, Yr = function(n) {
        return A4(Gr, F3(function(n, r, t) {
            return "<" + n + " " + A2(Er, "", t) + ">" + r + "</" + n + ">";
        }), A2(wr, "html", Nr), A2(wr, "body", n), Xr);
    }, Wr = F2(function(n, r) {
        return d(n, r);
    }), Hr = F3(function(n, r, t) {
        return n > 0 ? A3(Hr, n >> 1, $(r, r), 1 & n ? $(t, r) : t) : t;
    }), Kr = F2(function(n, r) {
        return A3(Hr, n, r, "");
    }), Qr = A2(Cr, function(n) {
        var r = n.a, t = n.b;
        if (1 === t.$) return Tr(r);
        var u = t.a;
        return 0 > v(u, r.length) ? Dr("length must be greater than or equal to the length of the solution") : Tr($(r, A2(Kr, u, " ")));
    }, A3(sr, Wr, A2(wr, "solution", Nr), kr(A2(wr, "length", zr)))), Ur = function(n) {
        return A2(Cr, n, Tr(0));
    }, Vr = F2(function(n, r) {
        return r.$ ? On : xn(n(r.a));
    }), Zr = _, nt = B, rt = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), tt = F2(function(n, r) {
        return A2(rt, function(r) {
            return s(r, n);
        }, r);
    }), ut = A3(sr, F2(function(n, r) {
        return "<script " + A2(Er, "", r) + ">\n" + n + "\n</ script>";
    }), A2(wr, "script", Lr), Xr), et = function(n) {
        return i([
            n
        ]);
    }, it = A2(mr, A2(hn, Vr(function(n) {
        return "<!-- " + n + " -->";
    }), Er("")), Xr);
    function ot() {
        return Ar(i([
            A3(sr, An, Ar(i([
                Nr,
                A2(Fr, i([
                    "bold",
                    "b"
                ]), A2(mr, function(n) {
                    return "__" + n + "__";
                }, bt())),
                A2(wr, "footnote", A2(mr, function(n) {
                    return "[^" + n + "]";
                }, Nr)),
                ft(),
                lt(),
                A2(Fr, i([
                    "formula",
                    "math"
                ]), A2(mr, function(n) {
                    return "$ " + n + " $";
                }, Nr)),
                A2(Fr, i([
                    "italic",
                    "i"
                ]), A2(mr, function(n) {
                    return "_" + n + "_";
                }, bt())),
                ct(),
                A2(Fr, i([
                    "strike",
                    "s"
                ]), A2(mr, function(n) {
                    return "~" + n + "~";
                }, bt())),
                A2(wr, "string", Nr),
                A2(wr, "symbol", Nr),
                A2(Fr, i([
                    "superscript",
                    "sup"
                ]), A2(mr, function(n) {
                    return "^" + n + "^";
                }, bt())),
                A2(Fr, i([
                    "underline",
                    "u"
                ]), A2(mr, function(n) {
                    return "~~" + n + "~~";
                }, bt())),
                A2(Fr, i([
                    "code",
                    "verbatim"
                ]), A2(mr, function(n) {
                    return "`" + n + "`";
                }, bt()))
            ])), it),
            ut,
            Yr(bt())
        ]));
    }
    function ft() {
        return A6(nt, F5(function(n, r, t, u, e) {
            return "{" + A2(Nn, " ", A2(jr, Er(""), i([
                r,
                t,
                u,
                e
            ]))) + "}{" + n + "}";
        }), A2(wr, "effect", bt()), A2(mr, Vr(kn), kr(A2(wr, "begin", zr))), A2(mr, Vr(kn), kr(A2(wr, "end", zr))), A2(mr, function(n) {
            return s(n, xn(!0)) ? xn("|>") : On;
        }, kr(A2(wr, "playback", Br))), kr(A2(wr, "voice", Nr)));
    }
    function ct() {
        return A5(Zr, F4(function(n, r, t, u) {
            return n + "[" + r + "](" + t + u + ")";
        }), A2(wr, "link", A2(Cr, function(n) {
            switch(n){
                case "link":
                    return Tr("");
                case "image":
                    return Tr("!");
                case "audio":
                    return Tr("?");
                case "video":
                    return Tr("!?");
                case "embed":
                    return Tr("??");
                default:
                    return Dr("Only link, image, audio, video, and embed are supported");
            }
        }, Nr)), A2(mr, Er(""), kr(A2(wr, "alt", bt()))), A2(wr, "url", Nr), A2(mr, A2(hn, Vr(function(n) {
            return ' "' + n + '"';
        }), Er("")), kr(A2(wr, "title", bt()))));
    }
    function at() {
        return A3(sr, F2(function(n, r) {
            return A2(Nn, " | ", A2(_n, F2(function(n, t) {
                return A2(tt, n, r) ? "( " + t + " )" : t;
            }), n));
        }), st(), A2(wr, "solution", Ar(i([
            qr(zr),
            A2(mr, et, zr)
        ]))));
    }
    function st() {
        return A2(wr, "options", qr(bt()));
    }
    function bt() {
        return Ar(i([
            Nr,
            vt()
        ]));
    }
    function vt() {
        return A2(mr, Nn(""), Ur(function() {
            return qr(ot());
        }));
    }
    function lt() {
        return A2(Cr, function(n) {
            switch(n){
                case "text":
                    return A2(mr, function(n) {
                        return "[[" + n + "]]";
                    }, Qr);
                case "selection":
                    return A2(mr, function(n) {
                        return "[[ " + n + " ]]";
                    }, at());
                default:
                    return Dr("Only selection and text are supported input types");
            }
        }, A2(wr, "input", Nr));
    }
    var dt = ot();
    ot = function() {
        return dt;
    };
    var ht = ft();
    ft = function() {
        return ht;
    };
    var $t = ct();
    ct = function() {
        return $t;
    };
    var pt = at();
    at = function() {
        return pt;
    };
    var gt = st();
    st = function() {
        return gt;
    };
    var mt = bt();
    bt = function() {
        return mt;
    };
    var yt = vt();
    vt = function() {
        return yt;
    };
    var wt = lt();
    lt = function() {
        return wt;
    };
    var xt = A3(sr, F2(function(n, r) {
        return "``` ascii" + r + "\n" + n + "\n```";
    }), Ar(i([
        A2(wr, "ascii art", Lr),
        A2(wr, "ascii", Lr)
    ])), A2(mr, A2(hn, Vr(An("  ")), Er("")), kr(A2(wr, "title", mt)))), Ot = A2(mr, A2(hn, Rr, A2(hn, jr(An("    ")), Nn("\n"))), Ar(i([
        A2(wr, "chart", Lr),
        A2(wr, "diagram", Lr)
    ]))), jt = A6(nt, F5(function(n, r, t, u) {
        var e = function(n, r, t) {
            return {
                a: n,
                b: r,
                c: t
            };
        }(r, t, u);
        return e.a.$ ? "```\n" + n + "\n```" : 1 === e.b.$ ? "``` " + e.a.a + "\n" + n + "\n```" : 1 === e.c.$ ? "``` " + e.a.a + "   " + e.b.a + "\n" + n + "\n```" : "``` " + e.a.a + "   " + (e.c.a ? "-" : "+") + e.b.a + "\n" + n + "\n```";
    }), A2(wr, "code", Lr), kr(A2(wr, "language", Nr)), kr(A2(wr, "name", Nr)), kr(A2(wr, "closed", Br)), Xr), At = A4(Gr, F3(function(n, r, t) {
        return "    --{{" + kn(n) + t + "}}--\n" + r;
    }), A2(wr, "id", zr), A2(wr, "comment", mt), A2(mr, A2(hn, Vr(An(" ")), Er("")), kr(A2(wr, "voice", Nr)))), Tt = F3(function(n, r, t) {
        var u = n(r);
        return u.$ ? t : A2(bn, u.a, t);
    }), kt = F2(function(n, r) {
        return A3(Or, Tt(n), t, r);
    }), Nt = A2(mr, function(n) {
        return "$$ " + n + " $$";
    }, A2(wr, "formula", Lr)), Et = A2(wr, "gallery", A2(mr, Nn("\n"), qr($t))), Jt = Ar(i([
        A2(wr, "horizontal rule", Tr("---")),
        A2(wr, "hr", Tr("---"))
    ])), qt = A2(wr, "solution", Ar(i([
        qr(zr),
        A2(mr, et, zr)
    ]))), Rt = function(n) {
        return "" === n;
    }, St = Ar(i([
        A2(wr, "paragraph", mt),
        A2(wr, "p", mt)
    ])), Ct = A3(sr, F2(function(n, r) {
        return $(A2(Nn, "\n", n), r);
    }), A2(wr, "project", Ar(i([
        qr(jt),
        A2(mr, et, jt)
    ]))), _r), Lt = kr(A2(wr, "hints", A2(mr, A2(hn, jr(An("[[?]] ")), Nn("\n")), qr(mt)))), _t = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(bn, t, n), r -= 1;
        }
    }), Bt = F2(function(n, r) {
        return A3(_t, t, n, r);
    }), Dt = A2(wr, "table", A4(Gr, F3(function(n, r, t) {
        var u = A2(Er, A2(Bt, Rn(n), "-----"), A2(Vr, jr(function(n) {
            switch(n){
                case "left":
                    return ":----";
                case "right":
                    return "----:";
                case "center":
                    return ":---:";
                default:
                    return "-----";
            }
        }), r));
        return A2(Nn, "\n", A2(jr, function(n) {
            return "| " + n + " |";
        }, $(i([
            A2(Nn, " | ", n)
        ]), $(i([
            A2(Nn, " | ", u)
        ]), A2(jr, Nn(" | "), t)))));
    }), A2(wr, "head", qr(mt)), kr(A2(wr, "orientation", qr(Nr))), A2(wr, "rows", qr(qr(mt)))));
    function Ft() {
        return Ar(i([
            A3(sr, F2(function(n, r) {
                return $(Rt(n) ? "" : n + "\n", r);
            }), it, Ar(i([
                St,
                Jt,
                It(),
                At,
                zt(),
                Mt(),
                xt,
                Ot,
                Pt(),
                Wt(),
                Et,
                Nt,
                Dt,
                jt,
                Ct,
                Yt(),
                Nr
            ]))),
            Yr(Kt())
        ]));
    }
    function It() {
        return A2(mr, Sr("> "), Ar(i([
            A2(wr, "blockquote", Kt()),
            A2(wr, "q", Kt())
        ])));
    }
    function Pt() {
        return A2(mr, Sr("> "), A3(sr, F2(function(n, r) {
            return n + "\n\n-- " + r;
        }), Ar(i([
            A2(wr, "citation", Kt()),
            A2(wr, "cite", Kt())
        ])), A2(wr, "by", mt)));
    }
    function zt() {
        return A2(mr, A2(hn, jr(A2(hn, Rr, A2(hn, _n(F2(function(n, r) {
            return n ? "  " + r : "* " + r;
        })), Nn("\n")))), Nn("\n\n")), Ar(i([
            A2(wr, "unordered list", Xt()),
            A2(wr, "ul", Xt())
        ])));
    }
    function Mt() {
        return A2(mr, A2(hn, _n(function(n) {
            return A2(hn, Rr, A2(hn, _n(F2(function(r, t) {
                return r ? "   " + t : kn(n + 1) + ". " + t;
            })), Nn("\n")));
        }), Nn("\n\n")), Ar(i([
            A2(wr, "ordered list", Xt()),
            A2(wr, "ol", Xt())
        ])));
    }
    function Xt() {
        return qr(Ar(i([
            Gt(),
            Kt()
        ])));
    }
    function Gt() {
        return Ar(i([
            Nr,
            Ur(function() {
                return Ft();
            })
        ]));
    }
    function Yt() {
        return A4(Gr, F3(function(n, r, t) {
            return $(A2(Nn, "\n", A2(_n, F2(function(n, t) {
                return A2(tt, n, r) ? "- [X] " + t : "- [ ] " + t;
            }), n)), t);
        }), A2(wr, "tasks", qr(Kt())), A2(mr, Er(t), kr(A2(wr, "done", Ar(i([
            qr(zr),
            A2(mr, A2(hn, _n(Wr), kt(function(n) {
                return n.b ? xn(n.a) : On;
            })), qr(Br))
        ]))))), _r);
    }
    function Wt() {
        return A5(Zr, F4(function(n, r, t, u) {
            return 1 === r.$ ? $(n, $(t, u)) : n + "\n" + (r.a + (t + u));
        }), Ut(), Lt, Ht(), _r);
    }
    function Ht() {
        return A2(mr, Er(""), kr(A2(mr, function(n) {
            return "\n************************\n\n" + n + "\n\n************************";
        }, A2(wr, "answer", Kt()))));
    }
    function Kt() {
        return Ar(i([
            Nr,
            Qt()
        ]));
    }
    function Qt() {
        return A2(mr, Nn("\n\n"), Ur(function() {
            return qr(Ft());
        }));
    }
    function Ut() {
        return A2(Cr, function(n) {
            switch(n){
                case "text":
                    return A2(mr, function(n) {
                        return "[[" + n + "]]";
                    }, Qr);
                case "selection":
                    return A2(mr, function(n) {
                        return "[[" + n + "]]";
                    }, pt);
                case "single-choice":
                    return A3(sr, F2(function(n, r) {
                        return A2(Nn, "\n", A2(_n, F2(function(n, t) {
                            return A2(tt, n, r) ? "- [(X)] " + t : "- [( )] " + t;
                        }), n));
                    }), gt, qt);
                case "multiple-choice":
                    return A3(sr, F2(function(n, r) {
                        return A2(Nn, "\n", A2(_n, F2(function(n, t) {
                            return A2(tt, n, r) ? "- [[X]] " + t : "- [[ ]] " + t;
                        }), n));
                    }), gt, qt);
                case "gap-text":
                    return A2(wr, "body", Gt());
                default:
                    return Dr('Supported quiz types are "text", "selection", "single-choice", "multiple-choice", "matrix", and "gap-text".');
            }
        }, A2(wr, "quiz", Nr));
    }
    var Vt = Ft();
    Ft = function() {
        return Vt;
    };
    var Zt = It();
    It = function() {
        return Zt;
    };
    var nu = Pt();
    Pt = function() {
        return nu;
    };
    var ru = zt();
    zt = function() {
        return ru;
    };
    var tu = Mt();
    Mt = function() {
        return tu;
    };
    var uu = Xt();
    Xt = function() {
        return uu;
    };
    var eu = Gt();
    Gt = function() {
        return eu;
    };
    var iu = Yt();
    Yt = function() {
        return iu;
    };
    var ou = Wt();
    Wt = function() {
        return ou;
    };
    var fu = Ht();
    Ht = function() {
        return fu;
    };
    var cu = Kt();
    Kt = function() {
        return cu;
    };
    var au = Qt();
    Qt = function() {
        return au;
    };
    var su = Ut();
    Ut = function() {
        return su;
    };
    var bu, vu, lu, du, hu = A2(wr, "body", Ar(i([
        cu,
        A2(mr, Nn("\n\n"), qr(eu))
    ]))), $u = A2(Cr, function(n) {
        return n > 0 && 7 > n ? Tr(A2(Kr, n, "#")) : Dr("Indentation must be between 1 and 6");
    }, A2(wr, "indent", zr)), pu = A3(sr, F2(function(n, r) {
        return n + " " + r;
    }), $u, A2(wr, "title", mt)), gu = A4(Gr, F3(function(n, r, t) {
        return n + (t + "\n\n") + r;
    }), pu, hu, Jr(!1)), mu = A2(mr, Nn("\n\n\n"), A2(wr, "sections", qr(gu))), yu = A3(sr, F2(function(n, r) {
        return $(n, r);
    }), Jr(!0), mu), wu = F2(function(n, r) {
        return r.$ ? $n(n(r.a)) : yn(r.a);
    }), xu = A2(hn, ar(yu), wu(Mn)), Ou = Y, ju = function(n) {
        return n;
    }, Au = F2(function(n, r) {
        return A3(qn, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), Tu = Y, ku = (vu = function(n) {
        var r = n.b;
        return A2(Au, ju, i([
            Ou(n.a),
            Tu(r)
        ]));
    }, function(n) {
        nn[n] && a(3);
    }(bu = "outPort"), nn[bu] = {
        e: cn,
        u: vu,
        a: function(n) {
            var r = [], t = nn[n].u, u = {
                $: 2,
                b: function(n) {
                    var r = setTimeout(function() {
                        n({
                            $: 0,
                            a: 0
                        });
                    }, 0);
                    return function() {
                        clearTimeout(r);
                    };
                },
                c: null
            };
            return nn[n].b = u, nn[n].c = F3(function(n, e) {
                for(; e.b; e = e.b)for(var i = r, o = t(e.a), f = 0; i.length > f; f++)i[f](o);
                return u;
            }), {
                subscribe: function(n) {
                    r.push(n);
                },
                unsubscribe: function(n) {
                    var t = (r = r.slice()).indexOf(n);
                    0 > t || r.splice(t, 1);
                }
            };
        }
    }, du = bu, function(n) {
        return {
            $: 1,
            k: du,
            l: n
        };
    }), Nu = function(n) {
        var r = xu(n);
        return d({
            E: n,
            F: r
        }, ku(d(!r.$, r.a)));
    }, Eu = {
        $: 2,
        m: t
    };
    lu = {
        Worker: {
            init: Z({
                av: Nu,
                aB: function() {
                    return Eu;
                },
                aD: F2(function(n) {
                    return Nu(n);
                })
            })(Nr)(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var u in t)u in r ? "init" == u ? a(6) : n(r[u], t[u]) : r[u] = t[u];
    }(n.Elm, lu) : n.Elm = lu;
}($d5909c9e2a02acdc$exports);


function $638dca7d0b6d9e37$export$2e2bcd8739ae039(json) {
    return new Promise((resolve, reject)=>{
        const app = (0, $d5909c9e2a02acdc$exports.Elm).Worker.init({
            flags: typeof json === "string" ? json : JSON.stringify(json)
        });
        app.ports.outPort.subscribe(([ok, rslt])=>{
            if (ok) resolve(rslt);
            else reject(rslt);
        });
    });
}


export {$638dca7d0b6d9e37$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=lib.js.map
